import { atom } from 'recoil'
import { ISystemEvent } from './systemEvents.types'

export interface ISystemEventFiltersState {
  type: Array<ISystemEvent['type']>
  created_lte: Date
  created_gte: Date
  search: string
}

const systemEventFiltersAtom = atom<ISystemEventFiltersState>({
  key: 'systemEventFilterState',
  default: {
    type: ['ALARM_SITUATION_INCIDENT', 'SYSTEM_LOG', 'LP_ERROR', 'MOVED_TO_MAINTENANCE'],
    created_lte: null,
    created_gte: null,
    search: '',
  },
})

export default systemEventFiltersAtom
